import { defineAsyncComponent } from "vue";
const FilePickerVue = defineAsyncComponent(() => import("./FilePicker-CDU2njOJ.mjs"));
export {
  FilePickerVue
};
